import { WS_URL } from "./config";
import mqtt from "precompiled-mqtt"
import mqttUsername from "./MqttUsername"

// MQTT connection configuration - centralized for easy maintenance
const MQTT_CONFIG = {
  url: WS_URL,
  username: "root",
  password: "tQ@*9XXiJZ^G$v"
}

/**
 * Sends an MQTT update message to trigger a refresh
 * @param {string} message - The message to publish (e.g., "tasks", "todos")
 * @returns {Promise} Resolves when the message is published, rejects on error
 */
export const mqttUpdate = (message = "tasks") => {
  return new Promise((resolve, reject) => {
    const client = mqtt.connect(MQTT_CONFIG.url, {
      clientId: "web_" + Math.random().toString(16).substr(2, 8),
      username: MQTT_CONFIG.username,
      password: MQTT_CONFIG.password
    });
    
    // Set a timeout to prevent hanging indefinitely
    const timeout = setTimeout(() => {
      client.end(true); // Force close
      reject(new Error("MQTT operation timed out"));
    }, 5000); // 5 second timeout
    
    // MQTT client setup
    client.on("connect", () => {
      console.log("MQTT connected");
      client.subscribe("control_" + mqttUsername, (err) => {
        if (err) {
          console.log("MQTT subscribe to control channel error: ", err);
          clearTimeout(timeout);
          client.end();
          reject(err);
        } else {
          client.publish("control_" + mqttUsername, message, (pubErr) => {
            clearTimeout(timeout);
            if (pubErr) {
              console.log("MQTT publish error: ", pubErr);
              client.end();
              reject(pubErr);
            } else {
              console.log("MQTT message published successfully");
              client.end();
              // Wait a bit for the end to complete before resolving
              setTimeout(() => resolve(), 100);
            }
          });
        }
      });
    });

    client.on("error", (err) => {
      console.log("MQTT error: ", err);
      clearTimeout(timeout);
      client.end(true);
      reject(err);
    });

    client.on("close", () => {
      console.log("MQTT connection closed");
    });
  });
}

